// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset Password Container */
.reset-password-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
}

.reset-password-box {
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    padding: 30px;
    width: 500px;
    text-align: center;
}

.reset-password-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 15px;
    text-align: left;
}

.form-group label {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
    color: #555;
}

.form-control {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 5px;
    transition: border-color 0.3s;
}

.form-control:focus {
    border-color: #007bff;
    outline: none;
}

/* Error and Success Messages */
.error-message {
    color: red;
    font-size: 14px;
    margin-bottom: 10px;
}

.success-message {
    color: green;
    font-size: 14px;
    margin-bottom: 10px;
}

/* Form Actions */
.form-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.btn {
    padding: 10px 15px;
    border-radius: 5px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    border: none;
}

.btn-primary {
    background-color: #007bff;
    color: white;
    transition: background-color 0.3s;
}

.btn-primary:hover {
    background-color: #0056b3;
}

.btn-secondary {
    background-color: #6c757d;
    color: white;
    transition: background-color 0.3s;
}

.btn-secondary:hover {
    background-color: #5a6268;
}


.message {
    margin-top: 5px;
    font-size: 14px;
}

.message.error {
    color: red;
    font-weight: bold;
}

.message.success {
    color: green;
    font-weight: bold;
}

.spinner {
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-left-color: #09f;
    border-radius: 50%;
    width: 15px;
    height: 15px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
.spinner-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5); 
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
@media (max-width: 480px) {


  .verifyContainer {
    width: 90%;
    padding: 20px;
  }

  .messageTextStyle {
    font-size: 16px;
  }

  .buttonStyle {
    font-size: 14px;
    padding: 8px 15px;
  }
}

@media (min-width: 481px) and (max-width: 768px) {

  .verifyContainer {
    width: 85%;
    padding: 25px;
  }

  .messageTextStyle {
    font-size: 18px;
  }

  .buttonStyle {
    font-size: 16px;
    padding: 10px 20px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .container {
    padding: 20px;
    font-size: 18px;
  }

  .verifyContainer {
    width: 70%;
    padding: 30px;
  }

  .messageTextStyle {
    font-size: 20px;
  }

  .buttonStyle {
    font-size: 18px;
    padding: 12px 25px;
  }
}

@media (min-width: 1024px) and (max-width: 1280px) {

  .verifyContainer {
    width: 60%;
    padding: 35px;
  }

  .messageTextStyle {
    font-size: 22px;
  }

  .buttonStyle {
    font-size: 20px;
    padding: 15px 30px;
  }
}

@media only screen and (min-width: 1281px) and (max-width: 1440px) {


  .verifyContainer {
    width: 50%;
    padding: 40px;
  }

  .messageTextStyle {
    font-size: 24px;
  }

  .buttonStyle {
    font-size: 22px;
    padding: 18px 35px;
  }
}

/* Màn hình rộng từ 1441px đến 1920px */
@media (min-width: 1441px) and (max-width: 1920px) {
 


  .verifyContainer {
    width: 40%;
    padding: 45px;
  }

  .messageTextStyle {
    font-size: 26px;
  }

  .buttonStyle {
    font-size: 24px;
    padding: 20px 40px;
  }
}

/* Màn hình rất lớn (trên 1921px) */
@media (min-width: 1921px) {


  .verifyContainer {
    width: 35%;
    padding: 50px;
  }

  .messageTextStyle {
    font-size: 28px;
  }

  .buttonStyle {
    font-size: 26px;
    padding: 25px 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AuthMethod/resetpassword.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA,+BAA+B;AAC/B;IACI,UAAU;IACV,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;AACA;;;EAGE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;;EAEE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;;EAEE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;;;EAGE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,uCAAuC;AACvC;;;;EAIE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,mCAAmC;AACnC;;;EAGE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":["/* Reset Password Container */\n.reset-password-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 80vh;\n}\n\n.reset-password-box {\n    background-color: #ffffff;\n    border-radius: 10px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n    padding: 30px;\n    width: 500px;\n    text-align: center;\n}\n\n.reset-password-title {\n    font-size: 24px;\n    font-weight: bold;\n    color: #333;\n    margin-bottom: 20px;\n}\n\n.form-group {\n    margin-bottom: 15px;\n    text-align: left;\n}\n\n.form-group label {\n    display: block;\n    font-weight: bold;\n    margin-bottom: 5px;\n    color: #555;\n}\n\n.form-control {\n    width: 100%;\n    padding: 10px;\n    font-size: 16px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    transition: border-color 0.3s;\n}\n\n.form-control:focus {\n    border-color: #007bff;\n    outline: none;\n}\n\n/* Error and Success Messages */\n.error-message {\n    color: red;\n    font-size: 14px;\n    margin-bottom: 10px;\n}\n\n.success-message {\n    color: green;\n    font-size: 14px;\n    margin-bottom: 10px;\n}\n\n/* Form Actions */\n.form-actions {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n}\n\n.btn {\n    padding: 10px 15px;\n    border-radius: 5px;\n    font-size: 16px;\n    text-align: center;\n    cursor: pointer;\n    border: none;\n}\n\n.btn-primary {\n    background-color: #007bff;\n    color: white;\n    transition: background-color 0.3s;\n}\n\n.btn-primary:hover {\n    background-color: #0056b3;\n}\n\n.btn-secondary {\n    background-color: #6c757d;\n    color: white;\n    transition: background-color 0.3s;\n}\n\n.btn-secondary:hover {\n    background-color: #5a6268;\n}\n\n\n.message {\n    margin-top: 5px;\n    font-size: 14px;\n}\n\n.message.error {\n    color: red;\n    font-weight: bold;\n}\n\n.message.success {\n    color: green;\n    font-weight: bold;\n}\n\n.spinner {\n    border: 2px solid rgba(0, 0, 0, 0.1);\n    border-left-color: #09f;\n    border-radius: 50%;\n    width: 15px;\n    height: 15px;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n.spinner-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.5); \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n@media (max-width: 480px) {\n\n\n  .verifyContainer {\n    width: 90%;\n    padding: 20px;\n  }\n\n  .messageTextStyle {\n    font-size: 16px;\n  }\n\n  .buttonStyle {\n    font-size: 14px;\n    padding: 8px 15px;\n  }\n}\n\n@media (min-width: 481px) and (max-width: 768px) {\n\n  .verifyContainer {\n    width: 85%;\n    padding: 25px;\n  }\n\n  .messageTextStyle {\n    font-size: 18px;\n  }\n\n  .buttonStyle {\n    font-size: 16px;\n    padding: 10px 20px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .container {\n    padding: 20px;\n    font-size: 18px;\n  }\n\n  .verifyContainer {\n    width: 70%;\n    padding: 30px;\n  }\n\n  .messageTextStyle {\n    font-size: 20px;\n  }\n\n  .buttonStyle {\n    font-size: 18px;\n    padding: 12px 25px;\n  }\n}\n\n@media (min-width: 1024px) and (max-width: 1280px) {\n\n  .verifyContainer {\n    width: 60%;\n    padding: 35px;\n  }\n\n  .messageTextStyle {\n    font-size: 22px;\n  }\n\n  .buttonStyle {\n    font-size: 20px;\n    padding: 15px 30px;\n  }\n}\n\n@media only screen and (min-width: 1281px) and (max-width: 1440px) {\n\n\n  .verifyContainer {\n    width: 50%;\n    padding: 40px;\n  }\n\n  .messageTextStyle {\n    font-size: 24px;\n  }\n\n  .buttonStyle {\n    font-size: 22px;\n    padding: 18px 35px;\n  }\n}\n\n/* Màn hình rộng từ 1441px đến 1920px */\n@media (min-width: 1441px) and (max-width: 1920px) {\n \n\n\n  .verifyContainer {\n    width: 40%;\n    padding: 45px;\n  }\n\n  .messageTextStyle {\n    font-size: 26px;\n  }\n\n  .buttonStyle {\n    font-size: 24px;\n    padding: 20px 40px;\n  }\n}\n\n/* Màn hình rất lớn (trên 1921px) */\n@media (min-width: 1921px) {\n\n\n  .verifyContainer {\n    width: 35%;\n    padding: 50px;\n  }\n\n  .messageTextStyle {\n    font-size: 28px;\n  }\n\n  .buttonStyle {\n    font-size: 26px;\n    padding: 25px 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
